import DateInput from './DateInput';

export type { DateInputProps } from './DateInput';
export default DateInput;
